import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class OrdersService {
  searchOrders = (params) => {
    return fetch(config.config.endpointUrls.searchOrders(), {
      method: 'POST',
      body: params
    })
  }
  createOrder = fields => {
    return fetch(config.config.endpointUrls.createOrder(), {
      method: 'POST',
      body: fields
    })
  }
  fetchOrders = params => {
    return fetch(config.config.endpointUrls.fetchOrders(params), {
      method: 'GET',
    })
  }
  updateOrder = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateOrder({ id }), {
      method: 'PATCH',
      body: fields
    })
  }
  fetchOrdersByCustomer = params => {
    return fetch(config.config.endpointUrls.fetchOrdersByCustomer(params), {
      method: 'GET'
    })
  }
  reassignOrder = ({ id, ...params }) => {
    return fetch(config.config.endpointUrls.reassignOrder({ id }), {
      method: 'POST',
      body: params
    })
  }
  refundOrder = ({ id, ...params }) => {
    return fetch(config.config.endpointUrls.refundOrder({ id }), {
      method: 'POST',
      body: params
    })
  }
  fetchOrder = params => {
    return fetch(config.config.endpointUrls.fetchOrder(params), {
      method: 'GET'
    })
  }
  editOrder = params => {
    return fetch(config.config.endpointUrls.editOrder(params), {
      method: 'POST',
      body: params
    })
  }
  exchangeOrder = params => {
    return fetch(config.config.endpointUrls.exchangeOrder(params), {
      method: 'POST',
      body: params
    })
  }
  cancelOrder = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.cancelOrder({ id }), {
      method: 'POST',
      body: fields
    })
  }
  fetchOrderConfig = () => {
    return fetch(config.config.endpointUrls.fetchOrderConfig(), {
      method: 'GET'
    })
  }
  updateOrderStatus = params => {
    return fetch(config.config.endpointUrls.updateOrderStatus(params), {
      method: 'PUT',
      body: { status: params.status }
    })
  }
  payByEmail = params => {
    return fetch(config.config.endpointUrls.payOrderByEmail(params), {
      method: 'POST'
    })
  }
}

export default new OrdersService()



// WEBPACK FOOTER //
// ../src/services/ordersService/ordersService.js